// video.js - JS to add video, because iOS is wonky
// Copyright (C) 2020 Saxton Technical Event Solutions

document.addEventListener('DOMContentLoaded', () => {
  const videos = {
  }
  const aAssets = document.querySelector('a-assets');
  for (const [id, src] of Object.entries(videos)) {
    const asset = document.createElement('video');
    asset.id = id;
    asset.src = src;
    asset.loop = true;
    asset.muted = true;
    asset.crossOrigin = "anonymous";
    asset.setAttribute('webkit-playsinline', 'webkit-playsinline');
    asset.setAttribute('playsinline', 'playsinline');
    aAssets.append(asset);
  }

  const clickHandler = () => {
    const videoAssets = document.querySelectorAll('video');
    console.log("playing videoAssets:", videoAssets);
    videoAssets.forEach(asset => {
      const promise = asset.play();
      if (promise && promise.catch) {   // older browsers don't return a value from play()
        promise.catch(err => {
          console.error("Can't play video:", err);
          window.alert("Videos can't play. Please view this site with a modern browser (maybe on another device?)");
        })
      }
    })
    document.removeEventListener('pointerdown', clickHandler);
  }
  document.addEventListener('pointerdown', clickHandler);
});
